/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { get, isEmpty } from 'lodash-es';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import propTypes from 'prop-types';
import injectSaga from 'utils/injectSaga';
import BackgroundStripped from '../../components/BackgroundStripped';
import LoadingScreen from '../../components/LoadingIndicator';
import PageHeading from '../../components/PageHeading';
import reCaptchaV3Plugin from '../../utils/third-party-plugins/recaptcha-v3';
import Footer from '../Footer';
import Header from '../Header';
import * as Yup from 'yup';
import FormBox from 'components/Form/formik.form';
import SqzButton from 'components/SqzButton';
import Modal from 'react-modal';
import Select from 'react-select';

import { fetchStatus, sendRequiredGovtInfo } from './actions';
import saga from './saga';
import makeSelectAppointment from './selectors';
import { Field, Formik } from 'formik';
import FormField from '../../components/FormField/formik.field';
import { validateZipcode } from '../../utils/validators';
import { states } from '../../utils/constants';

const apptConfirmPopupCustomStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
  },
};

const customStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: '#ffffff',
    height: '36px',
    minHeight: '36px',
    border: '1px solid #e5e5e5',
  }),
  valueContainer: styles => ({
    ...styles,
    height: '36px',
    minHeight: '36px',
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    color: isSelected ? '#000000' : '#666666',
  }),
  menu: styles => ({
    ...styles,
    overflow: 'hidden',
    zIndex: 20,
    position: 'relative',
  }),
  menuList: styles => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

class RequiredGovtInfo extends Component {
  constructor(props) {
    super(props);
    this.closePopupModal = this.closePopupModal.bind(this);
  }

  componentDidMount() {
    reCaptchaV3Plugin('Required Govt Info ');
    this.props.fetchStatus();
  }

  handleSendRequiredGovtInfo(values) {
    const authToken = localStorage.getItem('userToken');
    if (authToken) {
      this.props.sendRequiredGovtInfo({
        ...values,
      });
    }
  }
  getSignupFormSchema() {
    return Yup.object().shape({
      first_name: Yup.string()
        .required('Enter First Name')
        .min( 2, 'Minimum 2 characters required' )
        .matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
      last_name: Yup.string()
        .required('Enter Last Name')
        .min( 2, 'Minimum 2 characters required' )
        .matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
      address: Yup.string().required('Enter Address'),
      city: Yup.string()
        .required('Enter City')
        .min( 2, 'Minimum 2 characters required' )
        .matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
      state: Yup.string().required('Please Select State'),
      zip: Yup.string()
        .required('Enter Zip Code')
        .max(5, 'Maximum 5 digits required')
        .min(5, 'Minimum 5 digits required'),
    });
  }

  renderRequiredGovtForm() {
    const {
      sendingRequiredGovtInfo,
      sendingRequiredGovtInfoError,
    } = this.props.appointmentData;
    return (
      <Formik
        onSubmit={this.onSignup}
        initialValues={{
          first_name: '',
          last_name: '',
          address: '',
          city: '',
          state: '',
          zip: '',
        }}
        validationSchema={this.getSignupFormSchema()}
        render={({
          values,
          isSubmitting,
          isValid,
          errors,
          setFieldValue,
          submitForm,
          setFieldTouched,
          touched,
        }) => (
          <React.Fragment>
            <FormBox
              componentClasses={{
                formContainerClass: 'ac__form',
                formClass: 'register',
                buttonContainerClass: 'ac__actions account-create-btn',
                buttonClass: 'btn btn--secondary js-account-submit',
                errorClass: 'error-message',
              }}
              subComponentOrder={[{ name: 'children' }, { name: 'loader' }]}
              {...{
                isSubmitting,
                errors,
                setFieldValue,
                submitForm,
              }}
            >
              <div className="form-list legalFormList">
                <h4 className="legalFormHeaders">Legal Name</h4>
                <Field
                  name="first_name"
                  component={FormField}
                  value={values.first_name}
                  labelText="First Name"
                  type="text"
                  autoComplete="given-name"
                  componentClasses={{
                    fieldContainerClass:
                      'form-item form-item--half input-default form-item--login',
                    errorClass: 'input input-error',
                    inputClass: 'input',
                    errorMsgClass: 'error-message',
                  }}
                />
                <Field
                  name="last_name"
                  component={FormField}
                  value={values.last_name}
                  labelText="Last Name"
                  type="text"
                  autoComplete="family-name"
                  componentClasses={{
                    fieldContainerClass:
                      'form-item form-item--half input-default form-item--login',
                    errorClass: 'input input-error',
                    errorMsgClass: 'error-message',
                    inputClass: 'input',
                  }}
                />
                <>
                  <h4 className="legalFormHeaders">Home Address</h4>
                  <Field
                    name="address"
                    component={FormField}
                    value={values.address}
                    type="text"
                    labelText="Address"
                    componentClasses={{
                      fieldContainerClass:
                        'form-item form-item--half input-default form-item--login form-item--address',
                      errorClass: 'input input-error',
                      errorMsgClass: 'error-message',
                      inputClass: 'input',
                    }}
                  />
                </>
                <Field
                  name="city"
                  component={FormField}
                  value={values.address}
                  type="text"
                  labelText="City"
                  componentClasses={{
                    fieldContainerClass:
                      'form-item form-item--half input-default form-item--login form-item--city',
                    errorClass: 'input input-error',
                    errorMsgClass: 'error-message',
                    inputClass: 'input',
                  }}
                />
                <div className="form-item form-item--zip input-default form-item--state">
                  <label>State</label>
                  <Select
                    name="state"
                    options={states}
                    styles={customStyles}
                    value={
                      states.find(option => option.value === values.state) ||
                      null
                    }
                    onChange={selectedOption =>
                      setFieldValue('state', selectedOption.value)
                    }
                    onBlur={() => setFieldTouched('state', true)}
                    placeholder="Select State..."
                    classNamePrefix="react-select"
                    maxMenuHeight={240}
                    menuPortalTarget={document.body}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 20,
                      colors: {
                        ...theme.colors,
                        text: 'red',
                        primary25: 'lightgrey',
                        primary: 'lightgrey',
                      },
                    })}
                  />
                  {errors.state && touched.state && (
                    <div className="error-message">{errors.state}</div>
                  )}
                </div>
                <Field
                  name="zip"
                  component={FormField}
                  labelText="Zip Code"
                  type="number"
                  componentClasses={{
                    fieldContainerClass:
                      'form-item form-item--zip input-default form-item--zip',
                    errorClass: 'input input-error',
                    errorMsgClass: 'error-message',
                    inputClass: 'input',
                  }}
                />
                {errors.submissionError &&
                  this.renderErrors(errors.submissionError)}
                {!isEmpty(sendingRequiredGovtInfoError) &&
                !sendingRequiredGovtInfo ? (
                  <div className="error-message">
                    {' '}
                    {sendingRequiredGovtInfoError}{' '}
                  </div>
                ) : (
                  ''
                )}

                <div className="ac__actions account-create-btn">
                  <SqzButton
                    addClass={
                      sendingRequiredGovtInfo
                        ? 'btn btn--secondary js-account-submit is-loading'
                        : 'btn btn--secondary js-account-submit'
                    }
                    onClick={() => this.handleSendRequiredGovtInfo(values)}
                    type="button"
                    disabled={!isValid || sendingRequiredGovtInfo}
                  >
                    Continue
                    <i className="icon icon-form-btn-right" />
                  </SqzButton>
                </div>
              </div>
            </FormBox>
          </React.Fragment>
        )}
      />
    );
  }

  closePopupModal() {
    return this.props.history.push('/appointment/booked');
  }

  render() {
    const { sendingRequiredGovtInfo, requiredGovtInfo } = get(
      this.props,
      'appointmentData',
    );

    if (!sendingRequiredGovtInfo && !isEmpty(requiredGovtInfo)) {
      return (
        <Modal
          isOpen={!sendingRequiredGovtInfo && !isEmpty(requiredGovtInfo)}
          style={apptConfirmPopupCustomStyles}
        >
          <div className="text-center NotifyTherapistModal">
            <button
              type="button"
              className="modal__close btn-icon icon js-modal-close"
              onClick={this.closePopupModal}
            >
              <span className="screenreader">Close</span>
            </button>
            <div className="bubble">
              <p className="NotifyTherapistModal-bubble-text">
                Please bring your government-issued ID to the appointment.
              </p>
            </div>
            <div className="preg-modal__smiley">
              <i className="icon icon--smiley-blue-reflection" />
            </div>
            <div className="own-action-btn pb20-mb pt20">
              <div
                aria-label="geo-location-denied"
                className="btn btn--primary"
                onClick={this.closePopupModal}
              >
                OKAY
              </div>
            </div>
          </div>
        </Modal>
      );
    }
    return (
      <Fragment>
        <div className="appWrap govt-required-info">
          <div className="MainContentWrap higher-index">
            <div className="header-padding-adjustment">
              <Header
                showHamburgerMenu={false}
                // handleExitClick={() => {
                //   this.props.history.push('/');
                // }}
              />
            </div>
            <div id="appointmentApp" className="appointment-container">
              <div className="pressure__root">
                <PageHeading mobileTitle="PROVIDE GOV'T REQUIRED INFO">
                  PROVIDE GOV'T REQUIRED INFO
                </PageHeading>
                <BackgroundStripped
                  mobileTitle="Before your appointment, please provide the information below,
                  as required by Florida law (Section 480.043)."
                >
                  <span className="preferenceBackgoundStripped max-width-580">
                    Before your appointment, please provide the information
                    below, as required by Florida law (Section 480.043).
                  </span>
                </BackgroundStripped>
                <div className="ac container">
                  {this.renderRequiredGovtForm()}
                </div>
              </div>
            </div>
          </div>
          <div className="FootContentWrap">
            <Footer hideMobile />
          </div>
        </div>
      </Fragment>
    );
  }
}

RequiredGovtInfo.propTypes = {
  appointmentData: propTypes.object,
  fetchMassageTypes: propTypes.func,
  history: propTypes.object,
  setSelectedMassageType: propTypes.func,
  updateUserPressure: propTypes.func,
};

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
});

const withSagaSendRequiredGovtInfo = injectSaga({
  key: 'sendRequiredGovtInfo',
  saga: saga.watchSendRequiredGovtInfo,
});

const withSagaFetchStatus = injectSaga({
  key: 'fetchStatus',
  saga: saga.watchFetchStatus,
});

const withConnect = connect(
  mapStateToProps,
  {
    sendRequiredGovtInfo,
    fetchStatus,
  },
);

export default compose(
  withConnect,
  withRouter,
  withSagaSendRequiredGovtInfo,
  withSagaFetchStatus,
)(RequiredGovtInfo);
